import {UsersUpdateAPI} from "../../api/create";
import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

const initialState: any = {};

export const updateUserThunk = createAsyncThunk(
    'user/updateUser',
    async ({params}: {params:any}, { rejectWithValue }) => {
      try {
        const response = await UsersUpdateAPI(params); // Call your update API
        if (response?.error) {
          throw new Error(response.error);
        }
  
        toast.success("Profile updated successfully");
        const UserdetailString = localStorage.getItem("loggedUser") !== 'undefined' ? localStorage.getItem("loggedUser") : undefined
        const user_detail = UserdetailString ? JSON.parse(UserdetailString) : {}
        const responseDetail = response.result.user
        responseDetail['access'] = user_detail.access
  
        localStorage.setItem('loggedUser', JSON.stringify(responseDetail));
  
        return response.result; 
      } catch (error: any) {
        return rejectWithValue(error.message || 'User update failed');
      }
    }
  );
  

  const userUpdateSlice = createSlice({
    name: 'userUpdate',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(updateUserThunk.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(updateUserThunk.fulfilled, (state, action) => {
          state.isLoading = false;
          state.user = action.payload; // Update the user in the state
          state.error = null;
        })
        .addCase(updateUserThunk.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload as string;
        });
    },
  });
  

export default userUpdateSlice.reducer;